export enum Roundings {
  NO_ROUNDING = 'NO_ROUNDING',
  ROUND_TO_NEAREST = 'ROUND_TO_NEAREST',
  ROUND_UP_TO_NEAREST = 'ROUND_UP_TO_NEAREST',
}
